import { useState, useEffect } from "react";

const C = {
  red:     "#E30613",
  redDark: "#B0000E",
  navy:    "#0f172a",
  slate:   "#64748b",
  light:   "#94a3b8",
  white:   "#ffffff",
};

export default function ResetPassword() {
  const [token, setToken]           = useState("");
  const [tokenValido, setTokenValido] = useState(null);
  const [password, setPassword]     = useState("");
  const [confirm, setConfirm]       = useState("");
  const [showPass, setShowPass]     = useState(false);
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState("");
  const [exito, setExito]           = useState("");
  const [validando, setValidando]   = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get("token");
    if (!t) { setTokenValido(false); setValidando(false); return; }
    setToken(t);

    fetch(`${process.env.REACT_APP_API_URL}/validar-token?token=${t}`)
      .then(res => res.json())
      .then(data => { setTokenValido(data.ok); setValidando(false); })
      .catch(() => { setTokenValido(false); setValidando(false); });
  }, []);

  const handleReset = async (e) => {
    e.preventDefault();
    setError(""); setExito("");
    if (password !== confirm) { setError("Las contraseñas no coinciden."); return; }
    if (password.length < 6)  { setError("La contraseña debe tener al menos 6 caracteres."); return; }

    setLoading(true);
    try {
      const res  = await fetch(`${process.env.REACT_APP_API_URL}/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, nueva_password: password })
      });
      const data = await res.json();
      if (data.ok) {
        setExito("✅ Contraseña actualizada correctamente.");
        setTimeout(() => { window.location.href = "/"; }, 3000);
      } else {
        setError(data.mensaje || "Error al actualizar contraseña.");
      }
    } catch {
      setError("No se pudo conectar con el servidor.");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: "100%", boxSizing: "border-box",
    padding: "12px 14px", border: "2px solid #e2e8f0",
    borderRadius: "10px", fontSize: "14px",
    color: C.navy, background: "#f8fafc", outline: "none",
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: C.navy,
      fontFamily: "'Segoe UI', Arial, sans-serif"
    }}>
      <div style={{
        width: "100%", maxWidth: "420px", margin: "24px",
        background: "rgba(255,255,255,0.97)", borderRadius: "20px",
        padding: "40px 36px",
        boxShadow: "0 24px 80px rgba(0,0,0,0.4)"
      }}>

        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <div style={{ color: C.red, fontWeight: "800", fontSize: "22px", letterSpacing: "0.08em" }}>CLARO</div>
          <div style={{ color: C.light, fontSize: "11px", letterSpacing: "0.15em" }}>ICR Ofensores R3</div>
        </div>

        {validando ? (
          <div style={{ textAlign: "center", color: C.slate, padding: "20px" }}>
            ⏳ Validando enlace...
          </div>
        ) : !tokenValido ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "48px", marginBottom: "16px" }}>❌</div>
            <h3 style={{ color: "#991b1b", margin: "0 0 8px 0" }}>Enlace no válido</h3>
            <p style={{ color: C.slate, fontSize: "14px", margin: "0 0 20px 0" }}>
              Este enlace ya expiró o no es válido. Solicita uno nuevo.
            </p>
            <button onClick={() => window.location.href = "/"} style={{
              background: `linear-gradient(135deg, ${C.red}, ${C.redDark})`,
              color: "white", border: "none", borderRadius: "10px",
              padding: "12px 24px", fontSize: "14px", fontWeight: "700", cursor: "pointer"
            }}>
              Volver al inicio
            </button>
          </div>
        ) : exito ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "48px", marginBottom: "16px" }}>✅</div>
            <h3 style={{ color: "#15803d", margin: "0 0 8px 0" }}>Contraseña actualizada</h3>
            <p style={{ color: C.slate, fontSize: "14px", margin: 0 }}>
              Redirigiendo al login en unos segundos...
            </p>
          </div>
        ) : (
          <>
            <h2 style={{ margin: "0 0 6px 0", color: C.navy, fontSize: "22px", fontWeight: "700" }}>
              Nueva contraseña
            </h2>
            <p style={{ margin: "0 0 24px 0", color: C.slate, fontSize: "13px" }}>
              Ingresa tu nueva contraseña para continuar.
            </p>

            <form onSubmit={handleReset} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: "700", color: C.slate, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: "6px" }}>
                  Nueva contraseña
                </label>
                <div style={{ position: "relative" }}>
                  <input type={showPass ? "text" : "password"} value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Mínimo 6 caracteres"
                    style={{ ...inputStyle, paddingRight: "44px" }}
                    onFocus={(e) => e.target.style.borderColor = C.red}
                    onBlur={(e) => e.target.style.borderColor = "#e2e8f0"} />
                  <button type="button" onClick={() => setShowPass(!showPass)}
                    style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", fontSize: "16px" }}>
                    {showPass ? "🙈" : "👁️"}
                  </button>
                </div>
              </div>

              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: "700", color: C.slate, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: "6px" }}>
                  Confirmar contraseña
                </label>
                <input type="password" value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  placeholder="Repite la contraseña"
                  style={inputStyle}
                  onFocus={(e) => e.target.style.borderColor = C.red}
                  onBlur={(e) => e.target.style.borderColor = "#e2e8f0"} />
              </div>

              {error && (
                <div style={{ background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: "8px", padding: "10px 14px", color: "#991b1b", fontSize: "13px", fontWeight: "500" }}>
                  ⚠️ {error}
                </div>
              )}

              <button type="submit" disabled={loading} style={{
                width: "100%", padding: "13px",
                background: loading ? "#9ca3af" : `linear-gradient(135deg, ${C.red}, ${C.redDark})`,
                color: "white", border: "none", borderRadius: "10px",
                fontSize: "14px", fontWeight: "700", cursor: loading ? "not-allowed" : "pointer",
                boxShadow: loading ? "none" : "0 4px 16px rgba(227,6,19,0.35)"
              }}>
                {loading ? "⏳ Actualizando..." : "Guardar nueva contraseña →"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
